export class ObjsFailure
{
    error: {
        detail: string;
        status: number;
        title: string;
        traceId: string;
        type: string;
    };
    headers: any;
    message: string;
    name: string;
    ok: boolean;
    status: number;
    statusText: string;
    url: string;
}